import React, { useState, useEffect } from "react";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
import TextInputTwoRow from "components/GenericComponent/TextInputTwoRow";
import DateTimePicker from "../../../../components/GenericComponent/DateTimePicker";
import { convertDate } from "utils/formatDate";

export const ThongTinNguoiGop = ({ dataThongTin }) => {
  return (
    <>
      <div className="card-collapse collapse show">
        <div className="card-content">
          <div className="card-body">
            <div className="row">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-3">
                    <TextInputTwoRow
                      labelClass="col-md-4 label-control"
                      inputClass="form-control input-sm"
                      inputWrapClass="col-md-8"
                      wrapperClass="form-group row"
                      labelText="Họ tên"
                      inputProps={{
                        name: "ten",
                        value: dataThongTin.ten,
                        disabled: "disabled",
                      }}
                    ></TextInputTwoRow>
                  </div>
                  <div className="col-md-3">
                    <label
                      className="label-control color7-bold"
                      for="userinput2"
                    >
                      Ngày sinh
                    </label>
                    <br />
                    <div>
                      <DateTimePicker
                        value={convertDate(dataThongTin.ngaysinh)}
                        name="ngaysinh"
                        readOnly={true}
                      ></DateTimePicker>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <TextInputTwoRow
                      labelClass="col-md-4 label-control"
                      inputClass="form-control input-sm"
                      inputWrapClass="col-md-8"
                      wrapperClass="form-group row"
                      labelText="Địa chỉ"
                      inputProps={{
                        name: "diachi",
                        value: dataThongTin.diachi,
                        disabled: "disabled",
                      }}
                    ></TextInputTwoRow>
                  </div>

                  <div className="col-md-3">
                    <TextInputTwoRow
                      labelClass="col-md-4 label-control"
                      inputClass="form-control input-sm"
                      inputWrapClass="col-md-8"
                      wrapperClass="form-group row"
                      labelText="Số điện thoại"
                      inputProps={{
                        name: "dienthoai",
                        value: dataThongTin.dienthoai,
                        disabled: "disabled",
                      }}
                    ></TextInputTwoRow>
                  </div>

                  <div className="col-md-3">
                    <TextInputTwoRow
                      labelClass="col-md-4 label-control"
                      inputClass="form-control input-sm"
                      inputWrapClass="col-md-8"
                      wrapperClass="form-group row"
                      labelText="Số CCCD"
                      inputProps={{
                        name: "cmnd",
                        value: dataThongTin.cmnd,
                        disabled: "disabled",
                      }}
                    ></TextInputTwoRow>
                  </div>

                  <div className="col-md-3">
                    <label
                      className="label-control color7-bold"
                      for="userinput2"
                    >
                      Ngày cấp
                    </label>
                    <br />
                    <div>
                      <DateTimePicker
                        value={convertDate(dataThongTin.ngaycap)}
                        readOnly={true}
                        name="ngaycap"
                      ></DateTimePicker>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <TextInputTwoRow
                      labelClass="col-md-4 label-control"
                      inputClass="form-control input-sm"
                      inputWrapClass="col-md-8"
                      wrapperClass="form-group row"
                      labelText="Nơi cấp"
                      inputProps={{
                        name: "noicap",
                        value: dataThongTin.noicap,
                        disabled: "disabled",
                      }}
                    ></TextInputTwoRow>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
